export type ProjectParam =
    ProjectParams.CODE |
    ProjectParams.PHONE |
    ProjectParams.EMAIL |
    ProjectParams.RETENTION_PROMOCODE |
    ProjectParams.LOGIN |
    ProjectParams.PROMOCODE_CASHIER |
    ProjectParams.REGISTRATION |
    ProjectParams.EMAIL_VERIFY |
    ProjectParams.DEPOSIT |
    ProjectParams.CASHIER |
    ProjectParams.SUCCESS_DEPOSIT |
    ProjectParams.CANCEL_DEPOSIT |
    ProjectParams.ERROR_PAYMENT_REASON|
    ProjectParams.PAYMENT_RESULT ;

export enum ProjectParams {
    LOGIN = "login",
    RETENTION_PROMOCODE = "retPromo",
    EMAIL = "email",
    PHONE = "phone",
    REGISTRATION = "registration",
    CODE = "code",
    EMAIL_VERIFY = "emailCode",
    CASHIER = "cashier",
    DEPOSIT = "deposit",
    ERROR_PAYMENT_REASON = "reasonCode",
    SUCCESS_DEPOSIT = "successDeposit",
    CANCEL_DEPOSIT = "cancelDeposit",
    PAYMENT_RESULT = "paymentResult",
    PROMOCODE_CASHIER = "promocodeCashier",
}

export const projectParamMap: Record<ProjectParam, ProjectParam> = Object
    .values(ProjectParams)
    .reduce((res, item) => ({
        ...res,
        [item]: item,
    }), <Record<ProjectParam, ProjectParam>> {});
